(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fp-collection-gallery-assets"] && !Shopify.designMode) return;
  try {
    function fpInitCollectionGallery(root){
 if(root.dataset.fpReady)return;root.dataset.fpReady='true';
 const cards=[...root.querySelectorAll('.fp-a2-card')],colour=root.querySelector('select[data-fp-colour]'),range=root.querySelector('select[data-fp-range]'),swatches=[...root.querySelectorAll('[data-fp-swatch]')],resets=[...root.querySelectorAll('.fp-a2-reset')];
 for(const [field,select] of [['fpColour',colour],['fpRange',range]]){if(!select)continue;[...new Set(cards.map(c=>c.dataset[field]))].sort().forEach(v=>select.add(new Option(v,v)));}
 const update=()=>{let count=0;cards.forEach(c=>{const show=(!colour.value||c.dataset.fpColour===colour.value)&&(!range||!range.value||c.dataset.fpRange===range.value);c.hidden=!show;if(show)count++;});root.querySelector('[data-fp-count]').textContent=count;root.querySelector('.fp-a2-no-match').hidden=count>0;swatches.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.fpSwatch===colour.value)));resets[0].hidden=!colour.value&&(!range||!range.value);};
 colour.addEventListener('change',update);range?.addEventListener('change',update);
 swatches.forEach(b=>b.addEventListener('click',()=>{colour.value=b.dataset.fpSwatch;update();}));
 resets.forEach(b=>b.addEventListener('click',()=>{colour.value='';if(range)range.value='';update();}));
 root.querySelector('.fp-a2-controls').hidden=false;update();
}
document.querySelectorAll('[data-fp-collection-gallery]').forEach(fpInitCollectionGallery);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-fp-collection-gallery]').forEach(fpInitCollectionGallery));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fp-oak-mount-guidance"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(){
    var root=document.querySelector('.fp-oak-pdp');
    if(!root)return;
    var card=root.querySelector('[data-fp-oak-guidance]');
    var options=root.querySelector('.product-options');
    if(!card||!options||card.dataset.ready)return;
    card.dataset.ready='true';
    var selected=card.querySelector('[data-fp-oak-selected]');
    function sync(){
      var active=options.querySelector('.option-label.active:not(.option-color)');
      var select=options.querySelector('select.option-selector');
      if(active)selected.textContent=active.getAttribute('data-value');
      else if(select)selected.textContent=select.value;
    }
    new MutationObserver(sync).observe(options,{subtree:true,attributes:true,attributeFilter:['class']});
    options.addEventListener('change',sync);
    sync();
    var link=card.querySelector('[data-fp-oak-diagram]');
    if(link)link.addEventListener('click',function(e){
      var gallery=root.querySelector('.product-layout__main-media');
      var cells=Array.from(gallery.querySelectorAll('[data-media]'));
      var index=cells.findIndex(function(cell){return cell.getAttribute('data-media')==='11021487734940';});
      var thumb=root.querySelectorAll('.product-thumb__link')[index];
      if(!thumb||!gallery.classList.contains('flickity-enabled'))return;
      e.preventDefault();
      thumb.click();
      gallery.setAttribute('tabindex','-1');
      gallery.focus({preventScroll:true});
      gallery.scrollIntoView({behavior:'smooth',block:'center'});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
